export default __webpack_public_path__ + "static/media/Rayon.cc6cec19.png";